import { connect } from 'react-redux';

import { getProjectZoneId } from '../../../reducers/analyticsApp';
import UnitCardHeader from '../../../components/dashboards/cards/UnitCardHeader';

const mapStateToProps = (state) => {
  return {
    timezone: getProjectZoneId(state),
  };
};

export default connect(mapStateToProps)(UnitCardHeader);
